import { useEffect, useState, useCallback, useRef } from 'react';
import MenuTop from '../../components/menu/top/menu-top';
import './style.css';
import  { fetchProjectsGroupedService } from '../../features/project/service/project-service';
import Loader from '../../components/loader/loader';
import AccordionComponent from '../../components/accordion/accordion';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/inputs/common/input';

function Home() {
    const [ projects, setProjects ] = useState<any[]>([]);
    const [ isLoading, setIsLoading ] = useState(true);
    const [ filterValue, setFilterValue ] = useState('');
    const loadingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const navigate = useNavigate();

    // Função para garantir tempo mínimo de loading
    const setExtendedLoading = (duration: number = 800) => {
        // Limpa qualquer timeout existente
        if (loadingTimeoutRef.current) {
            clearTimeout(loadingTimeoutRef.current);
        }
        
        // Ativa o loading
        setIsLoading(true);
        
        // Define um novo timeout que vai desativar o loading após a duração especificada
        loadingTimeoutRef.current = setTimeout(() => {
            setIsLoading(false);
            loadingTimeoutRef.current = null;
        }, duration);
    };

    // Limpa o timeout quando o componente é desmontado
    useEffect(() => {
        return () => {
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current);
            }
        };
    }, []);

    // Efeito para carregar projetos iniciais
    useEffect(() => {
        const fetchProjects = async () => {
            setExtendedLoading();
            
            try {
                const projects = await fetchProjectsGroupedService();
                setProjects(projects);
            } catch (error) {
                console.log(error);
                setIsLoading(false);
            }
        };
    
        fetchProjects();
    }, []);

    // Utilizar debounce para evitar múltiplas requisições rápidas enquanto o usuário digita
    const debounce = (fn: Function, delay: number) => {
        let timer: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn(...args), delay);
        };
    };

    // Função para buscar projetos com debounce
    const debouncedFetchProjects = useCallback(
        debounce(async (value: string) => {
            // Ativa o loading com duração mínima garantida
            setExtendedLoading();
            
            try {
                const projects = await fetchProjectsGroupedService(value);
                setProjects(projects);
                // O loading será desativado pelo timeout definido em setExtendedLoading
            } catch (error) {
                console.log(error);
                setIsLoading(false);
            }
        }, 500), // 500ms de delay para permitir digitação contínua
        []
    );

    const handleRedirect = (id: string) => {
        navigate(`/projeto-list/${id}`);
    }

    const handleChange = ({ target: { value }}: any) => {
        setFilterValue(value);
        debouncedFetchProjects(value);
    }

    // Determina se há um filtro ativo
    const isFiltered = filterValue.trim() !== '';

    const isFullWidth = window.innerWidth > 768 ? 900 : window.innerWidth - 40;

    return (
        <div className="container-home">
            <MenuTop />
            {isLoading && <Loader />}
            <div className='container-home__content'>
                <div className="container-home__content__filter">
                    <Input 
                        placeholder="Filtrar projetos" 
                        onChange={handleChange} 
                        icon={true} 
                        value={filterValue}
                        width={isFullWidth}
                    />
                </div>
                <div className={`accordion-wrapper ${isLoading ? 'hidden' : 'visible'}`}>
                    <AccordionComponent 
                        data={projects} 
                        handleRedirect={handleRedirect} 
                        isFiltered={isFiltered} 
                    />
                </div>
            </div>
        </div>
    );
}

export default Home;